var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.46,
    clipPath: "url(#clip0_1584_84165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 29.8081C35.7025 29.8081 46 27.5723 46 24.8142C46 22.0562 35.7025 19.8203 23 19.8203C10.2975 19.8203 0 22.0562 0 24.8142C0 27.5723 10.2975 29.8081 23 29.8081Z",
    fill: "var(--empty-icon-accent-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5312 10.3747L32.2388 2.16896C31.8888 1.60964 31.3778 1.27148 30.8394 1.27148H15.1606C14.6223 1.27148 14.1112 1.60964 13.7612 2.16825L6.46875 10.3754V16.9666H39.5312V10.3747Z",
    fill: "var(--empty-icon-primary-color)",
    stroke: "var(--empty-icon-accent-color)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9093 12.6359C29.9093 11.4909 30.6238 10.5456 31.51 10.5449H39.5312V23.4841C39.5312 24.9987 38.5825 26.24 37.4109 26.24H8.58906C7.4175 26.24 6.46875 24.998 6.46875 23.4841V10.5449H14.49C15.3762 10.5449 16.0907 11.4888 16.0907 12.6338V12.6495C16.0907 13.7945 16.813 14.7191 17.6985 14.7191H28.3015C29.187 14.7191 29.9093 13.786 29.9093 12.6409V12.6359Z",
    fill: "var(--empty-icon-primary-color)",
    stroke: "var(--empty-icon-accent-color)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1584_84165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 29.25,
    fill: "var(--empty-icon-primary-color)",
    transform: "translate(0 0.558594)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.651634ad.svg";
export { ForwardRef as ReactComponent };